<template>
  <el-dialog
    style="z-index: 99999"
    :title="videoTitle"
    :visible.sync="visible"
    :modal-append-to-body="false"
    :before-close="onClose"
  >
    <video class="video-box" :src="videoSrc" controls :key="videoSrc"></video>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    videoTitle: {
      type: String,
      default: "",
    },
    videoSrc: {
      type: String,
      default: "",
    },
  },
  methods: {
    onClose() {
      this.$emit("onCloseVideo");
    },
  },
};
</script>
<style scoped>
.video-box {
  width: 100%;
  height: 400px;
}
/* ::v-deep .el-dialog__wrapper {
  z-index: 3000;
} */
</style>
